var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212.697,
    height: 184,
    viewBox: "0 0 212.697 184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration_cariera",
    "data-name": "illustration cariera",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28706",
    "data-name": "Path 28706",
    d: "M316.3,520.733l14.767-5.16A50.472,50.472,0,0,0,330,491.312c-5.6,13.487-23.075,17.258-32.777,28.174a30.359,30.359,0,0,0-7.035,25.356l-2.828,10.728a50.871,50.871,0,0,0,36.4-22.124,49.139,49.139,0,0,0,5.44-11.062C322.829,521.933,316.3,520.733,316.3,520.733Z",
    transform: "translate(-119.367 -386.602)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28707",
    "data-name": "Path 28707",
    d: "M369.724,409.428l10.312-11.762a50.471,50.471,0,0,0-12.87-20.593c1.765,14.5-11.586,26.383-14.654,40.662a30.359,30.359,0,0,0,6.363,25.533L361.7,454a50.872,50.872,0,0,0,20.786-37.179,49.142,49.142,0,0,0-.713-12.307C376,407.258,369.724,409.428,369.724,409.428Z",
    transform: "translate(-189.746 -307.509)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28708",
    "data-name": "Path 28708",
    d: "M422.491,604.792h74.562c2.191,0,3.972.441,3.972.986v29.164H418.508V605.778C418.508,605.233,420.29,604.792,422.491,604.792Z",
    transform: "translate(-328.675 -465.169)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28710",
    "data-name": "Path 28710",
    d: "M290.911,546.06l.7,5.677-21.563,5.389-1.028-8.378Z",
    transform: "translate(-141.341 -378.063)",
    fill: "#facca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28711",
    "data-name": "Path 28711",
    d: "M454.761,686.187l.572,9.135,3.885-.477,7.013,7.891a2.445,2.445,0,0,0,4.255-1.922l-1.325-10.8-4.072-1.389,3.754-1.2-.5-4.071Z",
    transform: "translate(-309.306 -519.565)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28712",
    "data-name": "Path 28712",
    d: "M489.563,506.974l-5.549,1.383-7.975-20.746,8.19-2.041Z",
    transform: "translate(-402.987 -336.183)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28713",
    "data-name": "Path 28713",
    d: "M680.614,705.683l6.978-7.922-.948-3.8.988-.185h.006l6.165-1.151,1.84-.345,4.461,13.137-3.981.994-1.646-3.581-.689,3.289-.194.92-10.556,2.63a2.444,2.444,0,0,1-2.424-3.987Z",
    transform: "translate(-608.203 -525.743)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28714",
    "data-name": "Path 28714",
    d: "M534.356,698.379l-2.012-.317c2.16,2.249,4.233,3.735,6.2,4.2l-.954-3.372Z",
    transform: "translate(-401.217 -529.744)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28715",
    "data-name": "Path 28715",
    d: "M553.048,551.563c1.9,4.258,3.277,6.984,3.277,6.984l.68-.357,1.791-.938,4.264-2.237.732-.385-.209-4.067-.929-17.985L562.259,525l16.253,8.59,19.231,10.165q1.181,2.058,2.347,4.006l13.066-8.962L599.9,519.447l-7.728-3.612,1.667-.323a12.238,12.238,0,0,0-1.44-1.72l-.585-.329s-36.773-20.256-47.354-9.87a8.414,8.414,0,0,0-2,3.295C538.831,517.306,547.891,540.045,553.048,551.563Z",
    transform: "translate(-478.683 -393.054)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28716",
    "data-name": "Path 28716",
    d: "M464.79,550.165a8.552,8.552,0,0,0,3.129,2.815,16.109,16.109,0,0,0,3.372,1.375c15.592,4.556,49.713-4.5,49.713-4.5l-1.341-4.741-.954-3.372-3.236-.508-2.012-.317L489.4,537.145l6.63-4.547,7.716-5.292,13.066-8.962,15.659-7.042c18.151-14.46,2.953-30.673,2.953-30.673l-10.159-7.2-3.3-2.338L501.7,481.46l-5.882,13.924-1.809,4.279-11.848,13.472-14.93,16.976-.117.132a10.713,10.713,0,0,0-1.215,1.077c-.138.135-.283.286-.431.449a14.431,14.431,0,0,0-3.024,5.03,12.569,12.569,0,0,0-.683,3.821.014.014,0,0,0,0,.015A16.833,16.833,0,0,0,464.79,550.165Z",
    transform: "translate(-382.333 -372.602)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28717",
    "data-name": "Path 28717",
    d: "M514.344,347.026c.808-.244,1.219-.541,1.294-.934.11-.577-.539-1.092-1.291-1.689-.524-.415-1.907-1.139-1.4-1.361,7.666-3.375-10.971-51.295-16.379-56.74-1.1-1.106-.968-3.352-2.432-5.351-4-5.457-7.51-6.446-14.5-8.416l-1.774-.5c-.8-.227.043,2.034-.372.518-.461-1.684-.938-3.426-2.083-4.259l-.075-.054-.092.006c-2.119.14-9.036,1.3-12.584,3.806l-.049.035-.028.053c-.654,1.22-.191,3.061.256,4.841.368,1.461-.516-.851-.868-.1-2.689,5.741-7.312,7.041-7.359,7.054l-.23.062.046.233c-1.208,6.266,7.081,25.68,8.873,38.753,1.821,13.281-8.558,28.24,6.694,25.725-.035.115-5.629,11.6-5.538,11.691C465.837,361.785,511.3,347.946,514.344,347.026ZM467.9,363.391Z",
    transform: "translate(-354.312 -232.156)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28718",
    "data-name": "Path 28718",
    d: "M740.109,287.094a4.36,4.36,0,0,0,4.307,5.114l5.121,14.625,4.88-6.405-5.611-12.906a4.384,4.384,0,0,0-8.7-.428Z",
    transform: "translate(-680.986 -242.682)",
    fill: "#facca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28719",
    "data-name": "Path 28719",
    d: "M618.756,346.6l9.282-2.007c16.742-5.3,22.482-11.844,24.354-16.4a10.555,10.555,0,0,0,.1-8.568l-.048-.064-6-5.844a7.509,7.509,0,0,0-11.223.848l-12.193,16.1-5.646-7.65-2.739-2.191-1.477-4.141-5.666-6.163-6.56,3.035,2.47,14.9,3.3,2.021.156,2.194.054.064Z",
    transform: "translate(-537.098 -261.429)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28720",
    "data-name": "Path 28720",
    d: "M590.929,436.806l.138,0a3.35,3.35,0,0,0,2.694-1.532,37.849,37.849,0,0,1,7.968-8.631c1.87-1.495,3.824-2.884,5.714-4.229,4.875-3.466,9.466-6.731,12.014-11.242,5.556-9.836-.987-23.537-10.335-29.681-10.485-6.891-24.276-7.972-37.618-8.114q-2.08-.022-4.162-.022h0a396.826,396.826,0,0,0-71.668,6.553c-7.861,1.45-16.09,3.227-22.7,7.539-6.573,4.286-10.569,11.036-10.179,17.2.569,8.994,10.1,15.714,18.784,17.471,8.275,1.673,16.871.542,25.971-.655,2.009-.264,4.086-.538,6.14-.775,22.325-2.58,64.264,5.373,66.038,5.713l1.76.337,6.83,8.789A3.278,3.278,0,0,0,590.929,436.806Z",
    transform: "translate(-462.766 -304.933)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28721",
    "data-name": "Path 28721",
    d: "M573.951,427.752h94.36a2.053,2.053,0,1,0,0-4.106h-94.36a2.053,2.053,0,1,0,0,4.106Z",
    transform: "translate(-545.204 -339.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28722",
    "data-name": "Path 28722",
    d: "M573.943,468.714H668.3a2.053,2.053,0,0,0,0-4.106H573.943a2.053,2.053,0,0,0,0,4.106Z",
    transform: "translate(-545.197 -368.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28723",
    "data-name": "Path 28723",
    d: "M573.95,509.675h11a2.053,2.053,0,1,0,0-4.106h-11a2.053,2.053,0,1,0,0,4.106Z",
    transform: "translate(-461.839 -396.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_442",
    "data-name": "Ellipse 442",
    cx: 14.054,
    cy: 14.054,
    rx: 14.054,
    ry: 14.054,
    transform: "translate(44.896 16.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28724",
    "data-name": "Path 28724",
    d: "M755.1,233.706a14.226,14.226,0,1,0-14.226-14.226A14.226,14.226,0,0,0,755.1,233.706Z",
    transform: "translate(-696.145 -188.551)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28725",
    "data-name": "Path 28725",
    d: "M774.263,243.731l-.09,0a1.838,1.838,0,0,1-1.362-.708L770.462,240a1.838,1.838,0,0,1,.322-2.58l.085-.066a1.839,1.839,0,0,1,2.581.323,1.341,1.341,0,0,0,2.031.1l4.769-5.034a1.841,1.841,0,0,1,2.6-.071l.078.075a1.838,1.838,0,0,1,.07,2.6l-7.4,7.811A1.837,1.837,0,0,1,774.263,243.731Z",
    transform: "translate(-719.311 -207.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28726",
    "data-name": "Path 28726",
    d: "M506.921,447.876a4.361,4.361,0,0,0,3.4-5.758l12.1-9.677-7.66-2.482-10.318,9.57a4.384,4.384,0,0,0,2.478,8.347Z",
    transform: "translate(-375.693 -344.124)",
    fill: "#facca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28727",
    "data-name": "Path 28727",
    d: "M492.348,317.456l-4.969-8.093c-10.549-14.04-18.623-17.289-23.542-17.545a10.555,10.555,0,0,0-8.116,2.746l-.045.066-3.524,7.6a7.509,7.509,0,0,0,4.518,10.308l19.231,6.17-5.347,7.862-1.16,3.31-3.418,2.766-3.938,7.388,5.037,5.184,13.244-7.268.812-3.787,2.019-.874.043-.073Z",
    transform: "translate(-330.133 -248.47)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M558.588,187.887h-.012a2.516,2.516,0,0,1-2.723-2.29l-1.217-13.986a18.76,18.76,0,0,1,.84-7.423,19.063,19.063,0,0,1,9.106-10.9,18.771,18.771,0,0,1,7.211-2.153c10.327-.915,14.084,1.26,20.355,17.042s1.219,14.007,1.219,14.007a2.521,2.521,0,0,1-.113,1,2.561,2.561,0,0,1-1.227,1.464,2.528,2.528,0,0,1-.964.288c-12.221,3.02-24.554,6.2-32.476,2.95Z",
    transform: "translate(-464.797 -150.961)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    d: "M617.286,181.047a13.838,13.838,0,0,1-14.214,21.245,13.677,13.677,0,0,1-8.767-5.853,13.838,13.838,0,0,1,14.2-21.239,13.677,13.677,0,0,1,8.778,5.847Z",
    transform: "translate(-500.629 -167.561)",
    fill: "#facca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M595.276,185.9a14.841,14.841,0,0,1,.664-5.87c.17-4.638,1.544-8.831,7.2-8.617a14.848,14.848,0,0,1,5.665-1.7l2.8-.258.094-.008a14.816,14.816,0,0,1,16.036,13.486l.024.28-5.92.539-2.51-5.465.088,5.687-3.057.28-1.266-2.757.044,2.867c-4.563,3.965-11.444,4.129-19.835,1.815Z",
    transform: "translate(-509.773 -163.719)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M583.312,209.814a2.475,2.475,0,0,0,.222,1.345,2.532,2.532,0,0,0,.385.592,2.559,2.559,0,0,0,.448.4,2.511,2.511,0,0,0,1.677.449l.111-.013.111-.017q.056-.01.111-.022l.11-.027,2.068-.565,2.357-6.437.493,5.665,9.406-2.552-2.091-24.04-16.012,1.471.436.425a11.06,11.06,0,0,1,2.966,5.2,18.029,18.029,0,0,1,.416,6.119,32.51,32.51,0,0,1-1.187,6.115,47.914,47.914,0,0,1-1.843,5.2,2.528,2.528,0,0,0-.182.682Z",
    transform: "translate(-478.974 -174.249)",
    fill: "#1d1d26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerIcon);
export default __webpack_public_path__ + "static/media/CareerIcon.9931448433be42cded71b0842c5ea196.svg";
export { ForwardRef as ReactComponent };